import { render, staticRenderFns } from "./AppealAssignment.vue?vue&type=template&id=dd68b2dc&scoped=true&"
import script from "./AppealAssignment.vue?vue&type=script&lang=js&"
export * from "./AppealAssignment.vue?vue&type=script&lang=js&"
import style0 from "./AppealAssignment.vue?vue&type=style&index=0&id=dd68b2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd68b2dc",
  null
  
)

export default component.exports